import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/**
 * @function
 * @name Unauthorized
 * @description Route which check authentication status and route to appropriate
 *  component
 *
 * @param {object} properties props object
 *
 * @returns {object} React Element
 *
 * @version 0.1.0
 * @since 0.1.0
 */

const Unauthorized = () => {
  const history = useHistory();
  const location = useLocation();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
      <h1>Unauthorized Access</h1>
      <p>You don't have permission to access this page.</p>
      <p>Attempted to access: {location.state?.from?.pathname || 'Unknown'}</p>
      <button onClick={handleGoBack} style={{ marginTop: '20px', padding: '10px 20px' }}>
        Go Back
      </button>
    </div>
  );
};

export default Unauthorized;

